import * as yup from 'yup';

// Copied from PersonalDetailsDE.schema.ts (postcode) — keep in sync if the desktop rule changes.
const postcodeRegexDE = /^[0-9]{2}[0-9]{3}$/;

export const homeAddressSchema = yup.object().shape({
  homeStreet: yup.string().trim().required('benötigt'),
  homeHouseNumber: yup.string().trim().required('benötigt'),
  homePostcode: yup
    .string()
    .required('benötigt')
    .matches(postcodeRegexDE, 'ungültige Eingabe'),
  homeTown: yup.string().trim().required('benötigt'),
});
